import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="8" height="18" viewBox="0 0 8 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.80005 16.9145C7.79982 16.6258 7.69557 16.3491 7.51023 16.1451L2.45683 10.5766C2.30387 10.4081 2.18254 10.208 2.09975 9.98785C2.01697 9.76767 1.97436 9.53167 1.97436 9.29334C1.97436 9.05501 2.01697 8.81901 2.09975 8.59883C2.18254 8.37864 2.30387 8.17859 2.45683 8.01008L7.50364 2.44519C7.68362 2.23985 7.78321 1.96484 7.78095 1.67937C7.7787 1.39391 7.67479 1.12084 7.49161 0.918981C7.30842 0.717121 7.06061 0.602619 6.80155 0.600139C6.5425 0.597658 6.29292 0.707397 6.10658 0.905719L1.05976 6.46626C0.381167 7.2155 4.85182e-05 8.2308 4.85182e-05 9.28935C4.85182e-05 10.3479 0.381167 11.3632 1.05976 12.1124L6.11317 17.681C6.25115 17.8331 6.42693 17.9368 6.61834 17.979C6.80975 18.0211 7.00821 17.9999 7.18867 17.9179C7.36913 17.8359 7.5235 17.6968 7.63231 17.5183C7.74112 17.3397 7.79949 17.1296 7.80005 16.9145Z" fill="black"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.800049 16.3144C0.800279 16.0257 0.904526 15.749 1.08987 15.545L6.14327 9.9765C6.29623 9.80799 6.41756 9.60794 6.50034 9.38775C6.58313 9.16757 6.62573 8.93157 6.62573 8.69324C6.62573 8.45491 6.58313 8.21891 6.50034 7.99873C6.41756 7.77855 6.29623 7.57849 6.14327 7.40999L1.09646 1.84509C0.916479 1.63976 0.816892 1.36474 0.819143 1.07928C0.821394 0.793812 0.925304 0.520744 1.10849 0.318883C1.29168 0.117023 1.53949 0.00252175 1.79854 4.11571e-05C2.0576 -0.00243944 2.30718 0.107299 2.49352 0.305621L7.54033 5.86616C8.21893 6.6154 8.60005 7.6307 8.60005 8.68925C8.60005 9.7478 8.21893 10.7631 7.54033 11.5123L2.48693 17.0809C2.34895 17.233 2.17316 17.3367 1.98175 17.3789C1.79034 17.421 1.59189 17.3998 1.41143 17.3178C1.23097 17.2358 1.0766 17.0967 0.967787 16.9182C0.858978 16.7396 0.80061 16.5295 0.800049 16.3144Z" fill="black"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
